if (!customElements.get('product-fulfillment-info')) {
  customElements.define(
    'product-fulfillment-info',
    class ProductFulfillmentInfo extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        const productInfo = this.closest('product-info');
        this.originalSectionId =
          productInfo?.dataset.originalSection ||
          (this.sectionId?.startsWith('quickadd-') ? this.sectionId.slice('quickadd-'.length) : this.sectionId);
      }

      connectedCallback() {
        this.freeThreshold = parseInt(this.dataset.freeThreshold, 10) || 50000;
        this.collectionFreeShipping = this.dataset.collectionFreeShipping === 'true';
        this.paidShipping = this.querySelector('[data-fulfillment-paid-shipping]');
        this.freeActive = this.querySelector('[data-fulfillment-free-active]');
        this.freeNote = this.querySelector('[data-fulfillment-free-note]');
        this.quantityInput = document.getElementById(`Quantity-${this.sectionId}`);
        this.purchaseRowPrice =
          document.querySelector(`purchase-row-price[data-section-id="${this.sectionId}"]`) ||
          document.querySelector('purchase-row-price.product-form__purchase-row-price');

        this.updateShippingState = this.updateShippingState.bind(this);
        this.unitPrice = 0;
        this.priceBreaks = [];

        if (this.purchaseRowPrice) {
          this.syncPriceFromPurchaseRow();
        }

        this.updateShippingState();

        this.quantityInput?.addEventListener('change', this.updateShippingState);
        this.quantityInput?.addEventListener('input', this.updateShippingState);

        if (typeof subscribe !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data?.sectionId !== this.sectionId && event.data?.sectionId !== this.originalSectionId) {
              return;
            }

            const variant = event.data.variant;
            if (variant) {
              this.unitPrice = variant.price;
              this.priceBreaks = variant.quantity_price_breaks || [];
            }

            requestAnimationFrame(() => {
              if (this.purchaseRowPrice) {
                this.syncPriceFromPurchaseRow();
              }
              this.updateShippingState();
            });
          });
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      syncPriceFromPurchaseRow() {
        this.unitPrice = parseInt(this.purchaseRowPrice.dataset.unitPrice, 10) || 0;

        if (this.purchaseRowPrice.dataset.priceBreaks) {
          try {
            this.priceBreaks = JSON.parse(this.purchaseRowPrice.dataset.priceBreaks);
          } catch (error) {
            this.priceBreaks = [];
          }
        }
      }

      getUnitPriceForQuantity(quantity) {
        if (this.purchaseRowPrice?.dataset.volumePricing === 'true' && this.priceBreaks.length) {
          const sorted = [...this.priceBreaks].sort((a, b) => b.minimum_quantity - a.minimum_quantity);
          for (const priceBreak of sorted) {
            if (quantity >= priceBreak.minimum_quantity) {
              return priceBreak.price;
            }
          }
        }

        return this.unitPrice;
      }

      getLineTotalCents() {
        const quantity = parseInt(this.quantityInput?.value, 10) || 1;
        const unitPrice = this.getUnitPriceForQuantity(quantity);
        return unitPrice * quantity;
      }

      updateShippingState() {
        const lineTotal = this.getLineTotalCents();
        const qualifiesFree = this.collectionFreeShipping || lineTotal >= this.freeThreshold;

        this.dataset.qualifiesFree = qualifiesFree ? 'true' : 'false';

        if (this.paidShipping) {
          this.paidShipping.classList.toggle('is-visible', !qualifiesFree);
        }

        this.querySelector('[data-fulfillment-shipping-row]')?.classList.toggle('is-active', qualifiesFree);

        this.freeActive?.classList.toggle('hidden', !qualifiesFree);
        this.freeNote?.classList.toggle('hidden', qualifiesFree);
      }
    }
  );
}
